export default __webpack_public_path__ + "static/media/happinessImg.ccf7f305.png";